import { useDataStore } from '@/lib/machine/use-data-store'
import { useDataStoreLocalStorage } from '@/lib/machine/use-data-store-local-storage'

export type FirmwareVersions =
  | { current: string; target: string; updateAvailable: true }
  | { current: string | null; target: string | null; updateAvailable: false }

export function useFirmwareVersions(): FirmwareVersions {
  const machineId = useDataStore(s => s.machineId)
  const refreshData = useDataStore(s => s.refreshData)
  const machineFirmware = useDataStoreLocalStorage(s => s.machineFirmware)

  const current = refreshData?.SW_VERSION ?? null
  const firmwareInfo = machineId ? machineFirmware[machineId] : null
  const target = firmwareInfo?.targetFirmwareVersion ?? null

  if (target !== null && current !== null && target !== current) {
    return { current, target, updateAvailable: true }
  }
  return { current, target, updateAvailable: false }
}
